export default "__VITE_ASSET__550f5342__"